import { apiFailureFromResponse, rememberApiError } from '@bayesprep/shared-ui/errors';
import { confirmSessionFailure } from './sessionFailure';
// Always use absolute URLs based on current origin to work with nginx reverse proxy
// This ensures all requests go through: nginx → API Gateway → microservices
const API_BASE_URL = '/api';

// Create a simple API client similar to axios
class ApiClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  async request(config) {
    const url = `${this.baseURL}${config.url}`;
    const token = localStorage.getItem('authToken');
    
    const headers = {
      'Content-Type': 'application/json',
      ...config.headers
    };

    // Add auth token if available
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const fetchConfig = {
      ...config,
      method: config.method || 'GET',
      headers
    };

    if (config.data) {
      fetchConfig.body = JSON.stringify(config.data);
    }

    const response = await fetch(url, fetchConfig);
    if (!response.ok) {
      const error = await apiFailureFromResponse(response);
      const sessionRetained = response.status === 401 && !url.includes('/auth/') && !await confirmSessionFailure(token);
      throw rememberApiError(error, sessionRetained);
    }
    return { data: await response.json(), status: response.status };
  }

  async get(url, config = {}) {
    return this.request({ ...config, method: 'GET', url });
  }

  async post(url, data, config = {}) {
    return this.request({ ...config, method: 'POST', url, data });
  }

  async put(url, data, config = {}) {
    return this.request({ ...config, method: 'PUT', url, data });
  }

  async delete(url, config = {}) {
    return this.request({ ...config, method: 'DELETE', url });
  }
}

const api = new ApiClient(API_BASE_URL);

export default api;
